<template>
  <div class="wrapper">
    <div v-if="user">
      <div class="user-account-menu">
        <img
          v-if="user.avatars"
          :src="user.avatars.default.url"
          alt="user avatar"
          class="user-avatar"
        />
        <user-icon v-else class="user-avatar" />
        <span class="down-icon">
          <down-icon></down-icon>
        </span>

        <ul class="dropdown">
          <li id="squared"><div class="square"></div></li>
          <li class="dropdown-item">
            <div>
              <AccountsIcon class="dropdown-icon" />
              <a
                class="dropdown-text"
                bohemia-login-button
                href="https://accounts.bistudio.com/profile"
                target="_blank"
                >Bohemia Account</a
              >
            </div>

            <div class="borders">
              <MyProfileIcon class="dropdown-icon" />
              <a class="dropdown-text" :href="userDataUrl" target="_blank"
                >My Profile</a
              >
            </div>
            <div>
              <ExitLogoutIcon class="dropdown-icon" />
              <a class="dropdown-text" :href="logoutUrl" bohemia-logout-button
                >Log Out</a
              >
            </div>
          </li>
        </ul>
      </div>

      <div class="user-active">
        <img
          v-if="user.avatars"
          :src="user.avatars.default.url"
          alt="user avatar"
          class="user-avatar"
        />
        <user-icon v-else class="user-avatar" />
        <div class="user-greeting">
          <span>Hello, {{ user.username }}</span>
          <div class="username-active-btn" v-if="user.profile">
            <div class="username-active-btn">
              <div class="active-btn">
                <ActiveBtn />
              </div>
              <p class="username">@{{ user.profile.username }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!user">
      <div v-if="loading">...</div>
      <div v-if="!loading">
        <a bohemia-login-button :href="loginUrl">
          <span class="non-user-login-text">
            <span id="avatar-span"
              ><user-icon class="user-avatar"></user-icon
            ></span>
            <span id="login-label">LOG IN</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import UserIcon from "../../assets/svg/user.svg?inline";
import ActiveBtn from "../../assets/svg/active-user-button.svg?inline";
import DownIcon from "./../icons/DownIcon.vue";
import AccountsIcon from "../../assets/svg/accounts_icon.svg?inline";
import ExitLogoutIcon from "../../assets/svg/exit_logout_icon.svg?inline";
import MyProfileIcon from "../../assets/svg/myprofile_icon.svg?inline";

export default {
  name: "account-menu",
  props: {
    scrolled: {
      type: Boolean
    },
    userDataUrl: {
      type: String,
      default: ""
    },
    user: {
      type: Object
    },
    loginUrl: {
      type: String
    },
    logoutUrl: {
      type: String
    }
  },
  components: {
    UserIcon,
    DownIcon,
    AccountsIcon,
    MyProfileIcon,
    ExitLogoutIcon,
    ActiveBtn
  },

  data: function() {
    return {
      loading: false,
      error: null
    };
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  cursor: pointer;

  &:hover {
    text-shadow: 0 0 1px #fff;
  }

  .icon-wrapper {
    margin-right: 0.5em;
  }

  .user-active {
    display: none;

    img {
      border-radius: 50%;
    }

    @media (max-width: 980px) {
      display: flex;
      flex-direction: row;
      color: #dce3e9;

      .user-avatar {
        margin: auto;
        margin-right: 5px;
        width: auto;
      }

      .user-greeting {
        justify-content: center;
        display: flex;
        flex-direction: column;

        .username-active-btn {
          display: flex;
          padding-top: 0.4em;

          .active-btn {
            padding-right: 0.2em;
            display: flex;

            svg {
              margin: auto;
            }
          }
          .username {
            font-size: 0.7em;
            margin: 0;
            cursor: pointer;
            padding: 0;
          }
        }
      }
      span {
        font-family: "politica-expanded", sans-serif;
        font-weight: 800;
      }
    }
    @media (max-width: 550px) {
      line-height: 12px;
      span {
        font-size: 1.1428571428571428em;
      }
      .username-active-btn {
        .username {
          font-size: 0.7em;
        }
      }

      .user-avatar {
        height: 35px;
      }
    }

    @media (min-width: 551px) and (max-width: 980px) {
      line-height: 20px;
      span {
        font-size: 1.9em;
      }

      .user-greeting {
        .username-active-btn {
          .username {
            font-size: 1em;
          }
        }
      }
      .user-avatar {
        height: 47px;
      }
    }
  }
}

#avatar-span {
  display: block;
}

#login-label {
  display: flex;
  align-items: center;
}

.down-icon {
  display: flex;
  align-items: center;
  margin-left: 0.2em;
}

[bohemia-login-button] {
  line-height: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  display: inline-block;
  color: #fff;

  &:hover {
    text-shadow: 0 0 1px #fff;
  }
}

.user-avatar {
  height: 30px;
  cursor: pointer;
  fill: currentColor;
}

.non-user-login-text {
  display: flex;
  justify-content: center;
}

@media (max-width: 550px) {
  .non-user-login-text {
    font-size: 1.1428571428571428em;
  }
}

@media (min-width: 551px) and (max-width: 980px) {
  .non-user-login-text {
    font-size: 1.8em;
  }
}

.user-account-menu {
  position: relative;
  display: flex;

  img {
    border-radius: 50%;
  }

  @media (max-width: 980px) {
    display: none;
  }

  .dropdown {
    position: absolute;
    top: 46px;
    right: -43px;
    max-height: 0;
    list-style: none;
    padding: 0;
    min-width: 200px;
    text-align: left;
    overflow: hidden;
    transition: max-height 0.5s;

    #squared {
      display: flex;
      background: transparent;
      justify-content: flex-end;
      height: 20px;
      margin-bottom: -10px;

      .square {
        margin-right: 65px;
        height: 10px;
        width: 10px;
        background-color: white;
        margin-top: 5px;
        transform: rotate(45deg);
        box-shadow: -0.5px -0.5px 0 0 grey;
      }
    }

    .borders {
      border-top: 0.5px solid #d8d8d8;
      border-bottom: 0.5px solid #d8d8d8;
    }

    .dropdown-item {
      cursor: pointer;
      background: white;
      display: flex;
      padding: 0.5em 1em;
      flex-direction: column;
      width: 190px;
      box-shadow: 0 0 2px grey;
      border-radius: 4px;
      z-index: 2;
      margin: 0 5px 5px 5px;

      div {
        display: flex;
        padding: 0.5em 0;
        cursor: pointer;

        a {
          display: inline-block;
          padding: 0 0.5em;
          cursor: pointer;
          color: #979797 !important;
          font-family: "Istok Web", sans-serif;
          font-weight: 400;
          letter-spacing: 0.15px;
          margin: auto 0;

          &:hover {
            text-shadow: 0 0 0.1px #979797;
          }
        }

        &:hover {
          text-shadow: 0 0 0.5px #979797;
          svg {
            stroke: rgba(0, 0, 0, 0.2);
            stroke-width: 0.5;
          }
        }
      }
    }
  }

  &:hover {
    .dropdown {
      max-height: 500px;
      top: 46px;
    }
  }
}

.user-avatar {
  margin: auto;
  margin-right: 5px;
  width: auto;
}
</style>
